import React from 'react';
import { useTranslation } from 'react-i18next';
import './ProductForm.css';

const ProductTracking = () => {
  const { t } = useTranslation();

  return (
    <div className="pm-page-card">
      <div className="pm-header">
        <h2 className="pm-header-title">{t('inventory.product_tracking_title')}</h2>
      </div>
      <div className="pm-placeholder-card">
        <div className="pm-placeholder-icon" aria-hidden="true">📦</div>
        <h3>{t('inventory.tracking_coming_soon')}</h3>
        <p>{t('inventory.coming_soon')}</p>
      </div>
    </div>
  );
};

export default ProductTracking;
